import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment";

import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import {isEmpty} from "@uw-it-sis/lib-react/lib/Utils";
import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";
import registrationDateStore from '@uw-it-sis/lib-react-myplan/lib/RegistrationDateStore';
import termStore from '@uw-it-sis/lib-react/lib/TermStore';

const RegistrationDateInfo = function (props) {
    if ( appStore.isStudent() || appStore.isAdviser() ) {
        const registrationDeadlinesLink = <a href={`https://registrar.washington.edu/priority-registration-dates-prior${TermUtils.makeTermLinkIdentifierFromTermId(props.termId)}/`} target="_blank">Registration deadlines</a>

        // Get the published term data for the selected term id (via component prop)
        let publishedTermData = termStore.get('publishedTerms').find(function (term) {
            return term.id === props.termId;
        });

        let registrationDateMap = {};

        if (publishedTermData) {
            registrationDateMap = registrationDateStore.getRegistrationDataForTerm(publishedTermData.codeName);
        }

        let formattedRegistrationDate = '';

        if (!isEmpty(registrationDateMap)) {
            formattedRegistrationDate = registrationDateMap.date.format("dddd, MMM D");
        }

        let registrationOpen = false;
        let now = moment(appStore.getNow());

        let lastAddDate = undefined;
        let firstRegPeriodDate = TermUtils.findPeriodOnePriorityRegDate(publishedTermData);

        if (publishedTermData) {
            publishedTermData.academicCalendar.forEach(function (entry) {
                if (entry.key === 'last_add_day') {
                    // use a time of 11:59pm to check that today's date is past the complete day of the last add day
                    lastAddDate = moment(entry.date + " 23:59", "YYYY-MM-DD hh:mm");
                }
            });
        }

        let isPastTermLastAddDate = false;
        if (!isEmpty(lastAddDate)) {
            isPastTermLastAddDate = now.isAfter(lastAddDate);
        }

        if (!isPastTermLastAddDate) {
            registrationOpen = now.isAfter(firstRegPeriodDate);
        }

        let registrationTiming;

        // Check if registration date data exist
        if (!isEmpty(registrationDateMap)) {
            // if now is before the registration date
            if (now.isBefore(registrationDateMap.date)) {
                // Check if reg date is a user's assigned P1 date or if generic P1 open date
                if (registrationDateMap.isPeriodOne) {
                    registrationTiming = `Your estimated registration date is ${formattedRegistrationDate} at 6:00am.`;
                } else {
                    registrationTiming = `Period I Priority Registration opens on ${formattedRegistrationDate}.`;

                }
            } else {
                // check if reg is open
                if (registrationOpen) {
                    registrationTiming = `You will be able to register online until ${lastAddDate.format("dddd, MMM D")}.`;
                }
            }
        }

        return (
            <p>
                <strong>{registrationTiming}</strong> {registrationDeadlinesLink}
            </p>
        );
    } else {
        // only shown for students and advisers
        return null;
    }
}

RegistrationDateInfo.propTypes = {
    termId: PropTypes.string.isRequired
}

export default RegistrationDateInfo;